import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { entityWithNameSchema } from '../types';

export const createGetAccountsQuery = () =>
	createAuthQuery({
		request: {
			method: 'GET',
			url: '/account/list/all',
			query: (permission) => (typeof permission === 'string' ? { permission } : {}),
		},
		response: {
			contract: zodContract(entityWithNameSchema.array()),
		},
	});
